module.exports = __webpack_public_path__ + "img/card-basic-mobile.1aba2cea.png";